<template>
  <div class="view-product-register-module-quiz-question">
    <div v-if="!!product">
      <h1 class="page-title">
        Cadastrar módulo
      </h1>
      <div class="row">
        <div class="col-lg-4">
          <steps
            :step="currentStep"
            :names="[
              'Configurações Básicas',
              'Adicionar Conteúdo',
              'Perguntas do QUIZ'
            ]"
          />
        </div>
        <div class="col-lg-8">
          <button class="btn" @click="$router.go(-1)">
            <h5 class="text-dark">
              <i class="icon-angle-left mr-3" /> Adicionar QUIZ
            </h5>
          </button>
          <hr />
          <h6 class="secondary-title-subtitle mb-6">
            Perguntas QUIZ
            <small>
              Determine as perguntas e respostas do QUIZ.
            </small>
          </h6>
          <draggable
            tag="div"
            class="list-group mb-6"
            handle=".handle"
            :list="questions"
          >
            <transition-group type="transition" name="flip-list">
              <div
                class="list-group-item question-card mb-5"
                v-for="(question, index) in questions"
                :key="`DnD-list-${index}`"
                :id="`id-${index}`"
              >
                <div class="question-card-header p-3 mb-3">
                  <button class="btn DnD p-0">
                    <i class="icon-drag-indicator handle mr-3" />
                  </button>
                  <strong class="flex-fill">
                    {{ `Pergunta ${index}` }}
                  </strong>
                  <button class="btn trash text-light p-0">
                    <i class="icon-trash" />
                  </button>
                </div>
                <div class="question-card-body p-6 mb-3">
                  <form-group
                    v-model="questions[index].title"
                    id="question-title"
                    placeholder="O que significa SEO?"
                    class="pt-5"
                  />
                  <hr />
                  <h6 class="secondary-title-subtitle mb-6">
                    Respostas
                    <small>
                      Selecione abaixo a resposta correta.
                    </small>
                  </h6>
                  <div
                    v-for="(alternative, idx) in questions[index].alternatives"
                    :key="`alternative-${idx}`"
                    class="d-flex align-items-center d-block pl-2 mb-3"
                  >
                    <form-group
                      class="pt-3"
                      type="radio"
                      v-model="questions[index].alternatives[idx].isAnswer"
                      :id="`alt-answer-${idx}`"
                      :options="[{ name: '' }]"
                    />
                    <form-group
                      class="flex-fill mr-3"
                      v-model="questions[index].alternatives[idx].text"
                      :id="`alt-text-${idx}`"
                      :placeholder="`Opção de resposta ${idx + 1}`"
                    />
                    <button
                      class="btn trash"
                      type="button"
                      @click="onRemoveAlternative(index, idx)"
                    >
                      <i class="icon-trash text-danger mr-3" />
                    </button>
                  </div>
                  <form v-on:submit.prevent="onAddAlternative(index)">
                    <div id="add-alternative" class="d-flex align-items-center">
                      <button
                        class="btn"
                        type="button"
                        @click="onAddAlternative(index)"
                      >
                        <i class="icon-plus text-primary mr-3" />
                      </button>
                      <form-group
                        class="flex-fill"
                        v-model="newAlternative.text"
                        :id="`alt-text-${idx}`"
                        placeholder="Clique para adicionar uma opção..."
                      />
                    </div>
                  </form>
                </div>
              </div>
            </transition-group>
          </draggable>

          <button
            class="btn btn-block btn-add-question text-primary"
            @click="onNewQuestion"
          >
            <i class="icon-checklist mr-3" />
            Adicionar pergunta
          </button>

          <div class="row pt-6">
            <div class="col-lg-6 mb-5">
              <button
                class="btn btn-block btn-outline-secondary"
                @click="$router.go(-1)"
              >
                Cancelar
              </button>
            </div>
            <div class="col-lg-6">
              <button
                class="btn btn-block btn-primary"
                :class="{ 'btn-secondary': !canMoveFoward }"
                :disabled="!canMoveFoward"
                @click="$emit('next')"
              >
                Salvar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Steps from "@/components/product/Steps";
import draggable from "vuedraggable";
import { mapState } from "vuex";

export default {
  components: {
    Steps,
    draggable
  },
  data() {
    return {
      questions: [],
      newAlternative: { isAnswer: false, text: "" },
      currentStep: 3
    };
  },
  computed: {
    ...mapState("product", ["product"]),
    canMoveFoward() {
      const can = this.questions.length;
      return can;
    }
  },
  methods: {
    previous() {
      this.currentStep -= 1;
    },
    onNewQuestion() {
      this.questions.push({
        title: "",
        alternatives: [
          {
            isAnswer: true,
            text: ""
          }
        ]
      });
    },
    onAddAlternative(index) {
      this.questions[index].alternatives.push(this.newAlternative);
      this.newAlternative = { isAnswer: false, text: "" };
    },
    onRemoveAlternative(questionIndex, altIndex) {
      this.questions[questionIndex].alternatives = this.questions[
        questionIndex
      ].alternatives.filter((_, i) => i !== altIndex);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.view-product-register-module-quiz-question {
  h5 {
    display: flex;
    align-items: center;
    i {
      font-size: 28px;
    }
  }

  .btn-add-question {
    background-color: rgba($color: #5576ec, $alpha: 0.05);
    border-radius: 4px;
    border: 1px dashed #d2d0d8;
  }

  .question-card {
    border: 1px solid #5576ec;
    border-radius: 4px 4px 0px 0px;
    padding: 0;

    .trash {
      i {
        font-size: 22px;
      }
    }

    .question-card-header {
      background-color: #5576ec;
      color: #fff;
      display: flex;
      align-items: center;

      button {
        color: #fff;
      }

      .DnD {
        i {
          font-size: 28px;
          opacity: 0.5;
        }
      }
    }

    .question-card-body {
      background: transparent;

      button {
        padding: 0;
      }

      .form-group,
      .radio-group,
      input[type="radio"]:checked:after {
        color: $success !important;
      }

      .plus {
        font-size: 28px;
      }
    }
  }
}
</style>
